import { styled } from '@compiled/react';
import { Link } from '@atlassian/react-resource-router';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NavigationLink = styled(Link)({
	textDecoration: 'none',
	'&:hover': {
		textDecoration: 'none',
	},
});
